import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import UploadDocumentContainer from 'components/UploadDocument/UploadDocument.container';
import {getRelationshipProofMeta, uploadRelationshipProof} from 'api';
import {handleApiError} from 'helpers';
import {LoaderContainer, Spinner} from '../commons';

import {RelationshipProofPrependContent} from './components';

const propTypes = {
  updateStatus: PropTypes.func.isRequired,
};

const RelationshipProof = ({updateStatus}) => {
  const [meta, setMeta] = useState(null);
  const [isFetchingMeta, setIsFetchingMeta] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedRelationship, setSelectedRelationship] = useState(null);
  const [errorMessage, setErrorMessage] = useState();

  const fetchMeta = useCallback(async () => {
    setIsFetchingMeta(true);
    try {
      const res = await getRelationshipProofMeta();
      setMeta(res.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsFetchingMeta(false);
    }
  }, []);

  useEffect(() => {
    fetchMeta();
  }, [fetchMeta]);

  const handleSubmitFile = async (formData) => {
    setErrorMessage(false);
    setIsUploading(true);
    try {
      formData.append('relationship', selectedRelationship?.key);
      const res = await uploadRelationshipProof(formData);
      if (res.status === 200) {
        updateStatus();
      } else if (res.status === 400) {
        res.json().then((data) => {
          setErrorMessage(data.detail);
        });
      } else if (!res.ok) {
        throw {
          response: {
            status: 400,
            data: {
              detail: {
                message: 'File Format Not Supported',
              },
            },
          },
        };
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsUploading(false);
    }
  };

  const relationshipOptions = (meta?.allowedRelationships || []).map((opt) => ({
    ...opt,
    id: opt.key,
  }));


  const isGuardianRelationship = selectedRelationship?.key === 'gua';
  const prependContent = (
    <RelationshipProofPrependContent
      relationshipOptions={relationshipOptions}
      selectedRelationship={selectedRelationship}
      onSelectRelationship={setSelectedRelationship}
      isGuardianRelationship={isGuardianRelationship}
    />
  );

  return isFetchingMeta ? (
    <LoaderContainer>
      <Spinner color="blue" message="Loading relationship details, please wait" />
    </LoaderContainer>
  ) : (
    <>
      {meta ? (
        <UploadDocumentContainer
          isLoading={isUploading}
          onSubmitDocument={handleSubmitFile}
          subHeading="<span>Define relationship with the minor</span>"
          heading="Relationship Details"
          documentOptions={[]}
          errorMessage={errorMessage}
          prependContent={prependContent}
          isBtnDisabled={!selectedRelationship}
          showUploadSection={isGuardianRelationship}
          isFileRequired={isGuardianRelationship}
        />
      ) : null}
    </>
  );
};

RelationshipProof.propTypes = propTypes;

export default RelationshipProof;
